let isOpenFlag = false
export const useCryptoNavActions = () => {

    const cryptoNavStatus = () => {
        const cryptoNav = document.querySelector(".crypto-navbar") as HTMLElement;

        return cryptoNav.classList.contains("translate-y-0")
    }

    const toggleCryptNav = () => {
        const cryptoNav = document.querySelector(".crypto-navbar") as HTMLElement;
        const header = document.querySelector(".header") as HTMLElement;
        const cryptoNavTrigger = document.querySelector(".crypto-nav-trigger") as HTMLButtonElement
        if (!isOpenFlag) {
            cryptoNavTrigger.classList.remove("-top-7", "h-[6px]", "translate-y-9")
            cryptoNav.classList.remove("translate-y-0")
            header.classList.remove("translate-y-10");
            // cryptoNav.classList.add("-translate-y-full")
            cryptoNav.classList.add("-translate-y-[100%]");

            cryptoNavTrigger.classList.add("top-0")
            header.classList.add("translate-y-0");
            cryptoNavTrigger.children[0].classList.add("rotate-180" ,"translate-y-2.5")
            isOpenFlag = true
        } else {
            header.classList.remove("translate-y-0");
            cryptoNavTrigger.classList.remove("top-0")
            // cryptoNav.classList.remove("-translate-y-full")
            cryptoNav.classList.remove("-translate-y-[100%]");

            cryptoNav.classList.add("translate-y-0")
            cryptoNavTrigger.classList.add("-top-7", "h-[30px]", "translate-y-9")
            header.classList.add("translate-y-10");
            cryptoNavTrigger.children[0].classList.remove("rotate-180" ,"translate-y-2.5")
            isOpenFlag = false
        }
    }

    return {toggleCryptNav, cryptoNavStatus}
}